import { useState, useEffect } from "react";
import axios from "axios";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import StickyHeader from "../components/StickyHeader";
import TextField from "@mui/material/TextField";
import CustomizedButton from "../components/CustomizedButton";
import Input from "@mui/material/Input";
import { useNavigate } from "react-router-dom";
import { Paper } from "@mui/material";
import config from "../config";

export default function BoardInsert() {
    const [board_title, setTitle] = useState("");
    const [board_content, setContent] = useState("");
    const [user, setUser] = useState(window.sessionStorage.getItem("id"));
    const [userName, setUserName] = useState("");

    useEffect(() => {
        axios
            .get(`${config.API_URL}/selectMember?member_id=${user}`)
            .then((res) => {
                if (res.data !== null) {
                    setUserName(res.data.member_name);
                } else {
                    alert("Failed to confirm info!");
                }
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    const handleSubmit = () => {};
    const navigate = useNavigate();
    const goBack = () => {
        navigate("/board");
    };
    const titleChange = (event) => {
        setTitle(event.target.value);
    };

    const contentChange = (event) => {
        setContent(event.target.value);
    };

    const handleInsert = () => {
        axios
            .post(`${config.API_URL}/customer/insert`, {
                member_id: window.sessionStorage.getItem("id"),
                board_title: board_title,
                board_content: board_content,
            })
            .then((res) => {
                navigate("/board");
            })
            .catch((e) => {
                console.error(e);
            });
    };

    return (
        <div>
            <StickyHeader />
            <Paper sx={{ padding: "16px", height: "100vh" }}>
                <Box
                    component="form"
                    sx={{
                        "& > :not(style)": { m: 1 },
                        paddingTop: "250px",
                        width: 800,
                        mx: "auto",
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <Box
                        sx={{
                            display: "flex",
                            pb: 1,
                        }}
                    >
                        <Typography sx={{ width: "150px", mt: 1, fontWeight: "bold" }} variant="h6" component="h4">
                            Author
                        </Typography>
                        <Typography sx={{ width: "120px", mt: 1, fontWeight: "bold" }} variant="h6" component="h4">
                            {user}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            pb: 1,
                        }}
                    >
                        <Typography
                            sx={{ width: "150px", mr: 3, mt: 2, fontWeight: "bold" }}
                            variant="h6"
                            component="h4"
                        >
                            Title
                        </Typography>
                        <Input sx={{ width: "100%", mt: 2 }} placeholder="Title" onChange={titleChange} />
                    </Box>

                    <Box
                        sx={{
                            display: "flex",
                            pb: 1,
                        }}
                    >
                        <Typography sx={{ width: "140px", mt: 3, fontWeight: "bold" }} variant="h6" component="h4">
                            Content
                        </Typography>
                        <TextField
                            sx={{ width: 630, mt: 3 }}
                            id="outlined-multiline-static"
                            multiline
                            rows={10}
                            placeholder="Enter content"
                            onChange={contentChange}
                        />
                    </Box>
                    <Box sx={{ display: "flex", ml: "auto" }}>
                        <Box sx={{ width: 100, ml: 79, mr: 3 }}>
                            <CustomizedButton label="Cancel" value="cancel" onClick={goBack}></CustomizedButton>
                        </Box>
                        <Box sx={{ width: 100 }}>
                            <CustomizedButton label="Confirm" value="insert" onClick={handleInsert}></CustomizedButton>
                        </Box>
                    </Box>
                </Box>
            </Paper>
        </div>
    );
}
